var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsosProductsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-2{fill-rule:evenodd;}.cls-3{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#939598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.65678,33.57586l-18.48678,10.67346,6.79386,3.92232c.36644.21156.8179.21156,1.18434,0l16.11838-9.30558c.7896-.45586.78961-1.59554.00002-2.0514l-5.60981-3.23881Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.97776,41.82896l18.4871-10.67333-6.3164-3.64674c-.36645-.21157-.81792-.21156-1.18437,0l-16.11822,9.30586c-.78959.45587-.78958,1.59554.00001,2.0514l5.13187,2.96282Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.88447,51.81206l-6.87174-3.96749v9.87964l-4.19211-2.17681v-10.1232l-5.12063-2.95643c-.76735-.44303-1.72654.11075-1.72654.99681v18.68835c0,.41122.21938.7912.57551.99681l16.18448,9.34412c.76735.44303,1.72653-.11076,1.72653-.99681v-18.68818c0-.41122-.21938-.7912-.5755-.99681Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.02656,68.06427v-17.12597c-.00039-.20383-.16571-.36885-.36954-.36885h-3.93025c-.20383.00039-.36885.16575-.36885.36954v1.03054c0,.17343-.11586.23385-.25728.13291-1.398-1.01418-3.46614-2.10229-5.95506-2.10229-1.39865,0-2.73409.24591-3.97002.73062-1.23663.48614-2.41214,1.22596-3.491,2.19963-1.22813,1.11725-2.16341,2.39084-2.77673,3.78528-.61337,1.3944-.92465,2.95228-.92465,4.62955,0,1.5657.27576,3.03401.81877,4.36091.54297,1.3269,1.36954,2.55429,2.4576,3.64881,1.08741,1.09448,2.30412,1.926,3.61398,2.47326,1.30985.54514,2.75331.82158,4.29267.82158,2.6453,0,4.63029-1.12649,5.9309-2.15061.14354-.10944.26083-.05045.26083.12862v1.08242c0,.20327.16631.36958.36958.36958h3.9302c.20366-.00078.36846-.16592.36885-.36958v-3.64595ZM62.09132,68.49784c-3.25498-.00009-6.23693-2.56227-6.23693-7.15191,0-3.60114,2.23589-7.09075,6.25853-7.09075,1.74264,0,6.16111.59702,6.16111,7.09075,0,6.51026-4.61237,7.15182-6.18271,7.15191Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsosProductsScraper);
export default __webpack_public_path__ + "static/media/asos-products-scraper.57b578887417e6551b1d7683c3a76b1a.svg";
export { ForwardRef as ReactComponent };